import { useLocation } from "react-router-dom";

// Components
import AuthLayout from "../components/AuthLayout/AuthLayout";

// Pages
import Login from "./Login";
import Register from "./Register";
import ForgotPassword from "./ForgotPassword";

const AuthPages = () => {
  const location = useLocation();

  const renderPage = () => {
    switch (location.pathname) {
      case "/register":
        return <Register />;
      case "/forgot-password":
        return <ForgotPassword />;
      default:
        return <Login />;
    }
  };

  return (
    <AuthLayout contentKey={location.pathname}>{renderPage()}</AuthLayout>
  );
};

export default AuthPages;
